<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'IP Static Route Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div @click="loadStaticRoute" class="btn" :class="{}" style="padding: 0px">
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
                <div
                  @click="addNewRow"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                <!-- <div
                  @click="editSelectRow"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div> -->
                <div
                  @click="delSelectRow"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
        <span style="float: right">
        <div class="pageButton">
          <button type="button" class="btn btn-primary" @click="clkApply()">
            {{ "Apply" }}
          </button>
          <span style="margin-left: 10px">
            <button
              type="button"
              class="btn btn-default"
              style="min-width: 77px"
              @click="clkCancel()"
            >
              {{ "Cancel" }}
            </button>
          </span>
        </div>
        </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    @change="selectall()"
                    v-model="selAll"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th
                  v-for="(value, key) in staticRouteTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in tStaticRouteTable"
                :key="row.index"
                :class="{
                  info: row.rowStatus === 'new' || row.rowStatus === 'edit',
                  delete: row.rowStatus === 'del',
                }"
                @dblclick="editDoubleClickRow(row)"
                @click.stop="
                  row.selected =
                    row.rowStatus === '' ? !row.selected : row.selected
                "
                style="
                  -moz-user-select: none; /*火狐*/
                  -webkit-user-select: none; /*webkit浏览器*/
                  -ms-user-select: none; /*IE10*/
                  -khtml-user-select: none; /*早期浏览器*/
                  user-select: none;
                "
              >
                <td width="40px">
                  <div v-if="row.rowStatus === ''">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + row.index"
                    />
                    <label></label>
                  </div>
                  <div v-else class="revocate" @click.stop="undoRow(row)">
                    <i class="fa fa-undo"></i>
                  </div>
                </td>
                <td
                  v-for="(value, key) in printableRow(row)"
                  :key="key"
                  :title="value"
                >
                  <!-- destIp 编辑 -->
                  <div
                    v-if="
                      key === 'destIp' &&
                      (row.rowStatus === 'new')
                    "
                  >
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': input_ip_check(row, 1) }"
                    >
                      <input
                        type="text"
                        v-model="row.newDestIp"
                        class="form-control table-edit"
                        maxlength="15"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{ 'glyphicon-remove': input_ip_check(row, 1) }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: input_ip_check(row, 1) ? 'block' : 'none',
                        }"
                        >{{ input_ip_check(row, 1) }}</small
                      >
                    </span>
                  </div>
                  <!-- subnetMask 编辑 -->
                  <div v-else-if="key === 'subnetMask' && row.rowStatus === 'new'">
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': input_ip_check(row, 2) }"
                    >
                      <input
                        type="text"
                        v-model="row.newSubnetMask"
                        class="form-control table-edit"
                        maxlength="15"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{ 'glyphicon-remove': input_ip_check(row, 2) }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: input_ip_check(row, 2) ? 'block' : 'none',
                        }"
                        >{{ input_ip_check(row, 2) }}</small
                      >
                    </span>
                  </div>
                  <!-- nexthop 编辑 -->
                  <div
                    v-if="
                      key === 'nexthop' &&
                      (row.rowStatus === 'new')
                    "
                  >
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': input_ip_check(row, 3) }"
                    >
                      <input
                        type="text"
                        v-model="row.newNexthop"
                        class="form-control table-edit"
                        maxlength="15"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{ 'glyphicon-remove': input_ip_check(row, 3) }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: input_ip_check(row, 3) ? 'block' : 'none',
                        }"
                        >{{ input_ip_check(row, 3) }}</small
                      >
                    </span>
                  </div>
                  <div v-else>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>

import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "staticRouteTable",
  components: {
    BlockCntr,
    InfoBox,
  },
  data() {
    return {
      page: en.page.ipconfigstatic,
      staticRouteTable: "",
      tStaticRouteTable: "",
      selAll: false,
      iBox: {},
      newRowCount: 0,
      maxNewRowCount: 5,
      newRow: {
        index: 0,
        destIp: "",
        subnetMask: "",
        proto: "",
        metric: "",
        nexthop: "",
        outIntf: "",
        isActive: true,
        rowStatus: "new",
        newDestIp: "",
        newSubnetMask: "",
        newNexthop: ""
      }
    }
  },
  created() {
    this.loadStaticRoute()
  },
  methods: {
    loadStaticRoute() {
      get("staticRouteTable")
        .then((res) => {
          this.staticRouteTable = res.data
          this.dataInit()
        })
        .catch((err) => {
          this.staticRouteTable = en.staticRouteTable
          this.dataInit()
        })
    },

    /* 页面数据初始化 */
    dataInit() {
        this.tStaticRouteTable = JSON.parse(JSON.stringify(this.staticRouteTable.data))
        this.tStaticRouteTable.forEach((element) => {
        this.$set(element, "rowStatus", "")
        this.$set(element, "selected", false)
        this.$set(element, "isActive", (element["isActive"] === "true" || element["isActive"] === true) ? true : false)
        })
        this.selAll = false
        this.newRowCount = 0
    },

    /* 页面提交函数 */
    clkApply() {
      var postData = {}
      var newRows = []
      var editRows = []
      var delRows = []
      var vt = this.tStaticRouteTable
      for (var v = 0; v < vt.length; v++) {
        if (
          vt[v]["rowStatus"] !== "new" &&
          vt[v]["rowStatus"] !== "edit" &&
          vt[v]["rowStatus"] !== "del"
        )
          continue
        if (vt[v]["rowStatus"] === "new" || vt[v]["rowStatus"] === "edit") {
          // 单元参数再次检查
          if (vt[v]["rowStatus"] === "new" && (this.input_ip_check(vt[v], 1) || this.input_ip_check(vt[v], 2) || this.input_ip_check(vt[v], 3))) {
            this.showAlertBox("warn", "warnning", "Fix the mistake first!")
            return
          }
          // 行内逻辑检查
        }
        // 新行添加冲突检查，编辑行前后对比检查，而后准备数据
        if (vt[v]["rowStatus"] === "new") {
          // 添加新行操作，进行冲突检查
          var skip = false
          for (var d = 0; d < vt.length; d++) {
            if ((d < v && vt[d]["rowStatus"] === "new") || v === d) continue
            // 冲突检查
          }
          if (
            vt[v]["newDestIp"] === this.newRow["newDestIp"] && vt[v]["newSubnetMask"] === this.newRow["newSubnetMask"] &&
            vt[v]["newNexthop"] === this.newRow["newNexthop"] 
          )
            continue
          var row = {}
          if (vt[v]["newDestIp"] !== this.newRow["newDestIp"] ||
              vt[v]["newSubnetMask"] !== this.newRow["newSubnetMask"] ||
              vt[v]["newNexthop"] !== this.newRow["newNexthop"])
          {
            row["destIp"] = vt[v]["newDestIp"]
            row["subnetMask"] = vt[v]["newSubnetMask"]
            row["nexthop"] = vt[v]["newNexthop"]
          }
          newRows.push(row)
        } else if (vt[v]["rowStatus"] === "edit") {// 编辑操作，进行编辑前后变更检查
        } else if (vt[v]["rowStatus"] === "del") {// 删除操作
          var row = {}
          row["destIp"] = vt[v]["destIp"]
          row["subnetMask"] = vt[v]["subnetMask"]
          row["nexthop"] = vt[v]["nexthop"]
          delRows.push(row)
        }
      }
      if (!newRows.length && !editRows.length && !delRows.length) {
        this.showAlertBox("info", "Info", "Nothing to do!")
        return
      }
      if (newRows.length) postData["add"] = newRows
      if (editRows.length) postData["edit"] = editRows
      if (delRows.length) postData["del"] = delRows
      post("staticRouteTable", postData)
        .then((res) => {
          if (
            res.data.code === undefined ||
            (res.data.code === 0 && res.data.msg === undefined)
          )
            this.showAlertBox("info", "Info", "Config successful!")
          else
            this.showAlertBox(
              res.data.code === 0 ? "info" : "warn",
              "Message",
              res.data.msg !== undefined ? res.data.msg : "Unknown error!"
            )
          this.loadStaticRoute()
        })
        .catch((err) => {
          this.showAlertBox("critical", "Error", err)
        })
    },

    /* 页面恢复函数 */
    clkCancel() {
      this.dataInit()
    },

    /* 参数输入IP检查 */
    input_ip_check(row, value) {
      var vt = ""
      if (value == 1)
        vt = row["newDestIp"]
      else if (value == 2)
        vt = row["newSubnetMask"]
      else if (value == 3)
        vt = row["newNexthop"]

        if (vt != "") {
          if (
            vt.match(
              /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/
            ) == null
          ) {
            return "invalid ip address"
          } else {
            var id = vt.split(".")
            let ip0 = Number(id[0])
            let ip1 = Number(id[1])
            let ip2 = Number(id[2])
            let ip3 = Number(id[3])
            if (
              id.length !== 4 ||
              ip0 < 0 ||
              ip0 > 255 ||
              ip1 < 0 ||
              ip1 > 255 ||
              ip2 < 0 ||
              ip2 > 255 ||
              ip3 < 0 ||
              ip3 > 255
            )
              return "invalid ip address"
          }
        }

      return null
    },

    /* 表头添加新行 */
    addNewRow() {
      var vt = this.tStaticRouteTable
      /*if (vt.length >= 4094)
        this.showAlertBox("info", "Warnning", "Table is full.")
      else*/ if (this.newRowCount >= this.maxNewRowCount)
        this.showAlertBox("info", "Warnning", "Too many new row.")
      else {
        vt.unshift(JSON.parse(JSON.stringify(this.newRow)))
        this.newRowCount++
        // 获取新行索引
        var vt1 = JSON.parse(JSON.stringify(vt))
        vt1.sort((a, b) => {
          return a.index - b.index
        })
        for (var idx = 1; idx <= 4094; idx++) {
          if (vt.length <= idx || idx != vt1[idx].index) {
            vt[0].index = idx
            break
          }
        }
      }
    },

    /* 双击编辑行 */
    editDoubleClickRow(row) {
      /*if (row["rowStatus"] === "") {
        row["rowStatus"] = "edit"
        row["selected"] = false
      }*/
    },

    /* 编辑选择的行 */
    editSelectRow() {
      /*var vt = this.tStaticRouteTable
      vt.forEach((element) => {
        if (element["rowStatus"] === "" && element["selected"]) {
          element["rowStatus"] = "edit"
          element["selected"] = false
        }
      })*/
    },

    /* 删除选择的行 */
    delSelectRow() {
      var vt = this.tStaticRouteTable
      vt.forEach((element) => {
        if (element["rowStatus"] === "" && element["selected"]) {
          element["rowStatus"] = "del"
          element["selected"] = false
        }
      })
    },

    /* 撤销行操作 */
    undoRow(row) {
      var vt = this.tStaticRouteTable
      if (row["rowStatus"] === "new") {
        var fi = vt.findIndex((r) => r.index === row.index)
        if (fi !== -1) {
          vt.splice(fi, 1)
          this.newRowCount--
        }
      } else if (row["rowStatus"] === "edit" || row["rowStatus"] === "del") {
        row["rowStatus"] = ""
        row["selected"] = false
      }
    },

    /* 行有效打印 */
    printableRow(row) {
      var prow = {}
      for (var c in row) {
        if (
          c === "rowStatus" ||
          c === "selected" ||
          c === "newDestIp" ||
          c === "newSubnetMask" ||
          c === "newNexthop"
        )
          continue
        prow[c] = row[c]
      }
      return prow
    },

    /* 选择全部行 */
    selectall() {
      this.tStaticRouteTable.forEach((element) => {
        if (element["rowStatus"] === "") element["selected"] = this.selAll
      })
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>